import React, { useEffect, useState } from "react";
import { Table, Form, Row, Col, FloatingLabel, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { AshaServices } from "../../../services/AshaService";
import EditAsha from "../EditAsha";
import AddAsha from "../AddAsha";
import { AppPagination, Loading } from "../../components/Index";

function AshaBlockAshaView() {
  const user = JSON.parse(localStorage.getItem("user"));
  const itemsPerPage = 10;

  const [asha, setAsha] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ cur: 1 });
  const [searchTerm, setSearchTerm] = useState("");
  const [addModalShow, setAddModalShow] = useState(false);

  useEffect(() => {
    getAsha();
  }, []);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, cur: 1 }));
  }, [searchTerm]);

  const getAsha = async () => {
    setLoading(true);
    try {
      const res = await AshaServices.getAshaByAshaBlockId(user.ashaBlockDetails.id);
      const data = Array.isArray(res) ? res : Object.values(res).filter((i) => i?.id);
      setAsha(data);
    } catch (error) {
      alert(error.message || "Failed to load Asha data");
      setAsha([]);
    }
    setLoading(false);
  };

  const deleteAsha = async (id) => {
    if (window.confirm("Do you want to delete?")) {
      setLoading(true);
      try {
        const res = await AshaServices.deleteAsha(id);
        if (res?.status === 200) {
          alert(res.message);
          getAsha();
        } else {
          alert("Error while deleting");
        }
      } catch (error) {
        alert(error.message);
      }
      setLoading(false);
    }
  };

  const filteredAsha = asha.filter((i) =>
    (i.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (i.preDefinedAshaId || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (i.mobileNo || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const startIndex = (pagination.cur - 1) * itemsPerPage;
  const paginatedAsha = filteredAsha.slice(startIndex, startIndex + itemsPerPage);
  const maxPage = Math.ceil(filteredAsha.length / itemsPerPage);

  return (
    <div>
      <Row className="w-100 mb-3">
        <Col>
          <Form.Control
            type="text"
            placeholder="Search by Asha ID or Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="mt-3"
          />
        </Col>
        <Col className="d-flex align-items-center justify-content-end mt-3">
          <Button className="custom-btn" onClick={() => setAddModalShow(true)}>
            Add Asha
          </Button>
        </Col>
      </Row>

      <AddAsha
        show={addModalShow}
        onHide={() => setAddModalShow(false)}
        onClose={() => getAsha()}
      />

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sl no</th>
            <th className="list-item-align-center">Asha Name</th>
            <th className="list-item-align-center">Asha ID</th>
            <th className="list-item-align-center">Mob no</th>
            <th className="list-item-align-center">Edit</th>
            <th className="list-item-align-center">Delete</th>
          </tr>
        </thead>
        <tbody>
          {!loading &&
            paginatedAsha.map((i, index) => (
              <tr key={i.id}>
                <td>{startIndex + index + 1}</td>
                <td className="list-item-align-center">{i.name}</td>
                <td className="list-item-align-center">{i.preDefinedAshaId}</td>
                <td className="list-item-align-center">{i.mobileNo}</td>
                <td className="list-item-align-center">
                  <EditAsha asha={i} onClose={() => getAsha()} />
                </td>
                <td className="list-item-align-center">
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => deleteAsha(i.id)}
                    size="lg"
                    style={{ cursor: "pointer" }}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      {filteredAsha.length < 1 && !loading && (
        <h3 style={{ color: "#e77225", textAlign: "center" }}>
          No results found
        </h3>
      )}

      {loading && <Loading />}

      <div className="d-flex justify-content-center my-3">
        <AppPagination
          curPage={pagination.cur}
          maxPage={maxPage}
          changePage={(page) => setPagination((prev) => ({ ...prev, cur: page }))}
        />
      </div>
    </div>
  );
}

export default AshaBlockAshaView;
